import formatTableJson from '@manage/config/tableComponentParams.js'

export default formatTableJson([
  {
    filed: 'name',
    label: '类型名称'
  },
  {
    filed: 'info',
    label: '描述'
  }
])
